export default {
  messages: {
    companyName: '上海沛熙管理咨询有限公司',
    home: '首页',
    about: '关于我们',
    products: '专业服务',
    contact: '联系我们',
    copyright: '© {year} — 上海沛熙管理咨询有限公司',
    welcome: '欢迎来到我们的公司！'
  }
}